import Service from "../../../Services/index";

const Users = {
    namespaced: true,
    state: {
        user_list: [],
        // showing:[]
    },
    mutations: {
        // SET_SHOW_INFORMATION: (state, res) =>{
        //     state.showing = res;
        // }
    },
    actions: {
        get({ commit }, data) {
            return Service.users.get(data.page?data.page:1,data.text)
        },
        show({ commit },id) {
            return Service.users.show(id)
        },
        update({ commit },data) {
            return Service.users.update(data)
        },
        getList() {
            return Service.users.getList()
        },
        register({ commit },data) {
            return Service.users.register(data).then(res=>{
                // commit('SET_SHOW_INFORMATION',res)
                return res
            })
        },
    }
};

export default Users;
